import React from 'react'
import musicLogo from './../asses/not-found/music_logo-removebg-preview.png'
import logo from "./../logo.svg";
import Barnav from "./Frontend1/barnav/Barnav";
import { hamburguesas, drinks, desserts, burgers, dessertsEnglish } from "./../Variables";
import { passwords } from "./../Variables";
import Carbuy from "./Carbuy";
import logoMacDonalds from "./../asses/not-found/logo-removebg-preview.png";
// import Admin from "./AdminFrontend/Admin";
import Comprobate from "./Comprobate";

import iconoPostre from './../asses/not-found/iconoPosttre-removebg-preview.png'

import iconoHamburguesa from './../asses/not-found/hamburguesaIcono-removebg-preview.png'

import iconoBebida from './../asses/not-found/bebidaicono-removebg-preview (1).png'

import music from './../sounds/GTA_San_Andreas_Theme_Song_Full_[_YouConvert.net_].mp3'
import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
// import ChatUsers from './ChatUsers';
import Footer from './Footer';
import { io } from "socket.io-client";
import imgLogo from './../asses/not-found/logo-removebg-preview.png'

import chatSound from './../sounds/Outlook notification sound.mp3'

import imgIconUsa from '../asses/not-found/usa-icon-removebg-preview.png'
import imgIconEspaña from '../asses/not-found/españa-icono-removebg-preview.png'

function Home({api25, ip1, setBarnavState, setConsoleAdmin, consoleAdmin, setSecurityAdmin, securityAdmin, visibilityClientFrontend, setVisibilityClientFrontend }) {
  const [freeVersion, setFreeVersion] = useState(true)  
  const [visibilityChatClient, setVisibilityChatClient] = useState(false)

  const [visibilityHamburguesas, setVisibilityHamburguesas] = useState(false);
  let [visibilityCar, setVisibilityCar] = useState(false);
  let [totalPay, setTotalPay] = useState(0);
  const [productsTocar, setProductsToCar] = useState([]);
  const [buy, setBuy] = useState({ products: null, table: 0, totalPayOrder: 0 });
  // let [tableNumber, setTableNumber] = useState(0);
  const [mensajes, setMensajes] = useState([]);

  const [orderSucessFull, setOrderSucessFull] = useState(false)
  let [numberOrders, setNumberOrders] = useState(0)
  const [alert, setAlert] = useState("")
  // const [visibilityClientFrontend, setVisibilityClientFrontend] = useState(true)
  const [productCuantity, setProductCuantity] = useState(0)

  const [numberBurgers, setNumberBurgers] = useState(0)
  const [alertTable, setAlertTable] = useState(0)
  const [aprobates, setAprobates] = useState(false)
  const [numberSameProduct, setNumberSameProduct] = useState(0)
  const [initiatedComprobated, setInitiatedComprobated] = useState(false)
  const [stateShowErrorInititated, setStateShowErrorInititated] = useState(true)


  const [visibilityPreSend, setVisibilityPreSend] = useState(false)
  // const [mensajes, setMensajes] = useState([]);
  // const [redireccionamiento, setRedireccionamiento] = useState("")

  //REDIRECCIONAMIENTO
  const { tableNumber } = useParams()

  // reportando nueva coneccion a los administradores
let theconeccction = 0
  const centralApi = "https://apicentral-67bm.onrender.com"
const restaurantName = "Burger shop"
const increaseConnections = async () => {
theconeccction = theconeccction + 1
if(theconeccction === 1){
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ restaurantName })
  };

  try {
    const response = await fetch(`${centralApi}/api/increase/connect`, config);
    const data = await response.json();

    if (response.ok) {
      console.log("Solicitud enviada con éxito:", data);
    } else {
      console.error("Error en la respuesta:", data);
    }
  } catch (err) {
    console.error("No se pudo enviar la solicitud ---->", err);
  }}
};

useEffect(() => {
  // console.log('Enviando solicitud para aumentar conexiones');
  increaseConnections();
}, []);


  // LICENCIA

// eliminando barra de navegacion de la plataforma central

  useEffect(() => {
setBarnavState(false)
  }, [])

  // FUNCIONES

  // visibilidades menu

  const [visibility1, setVisibility1] = useState(true)

  const [visibility2, setVisibility2] = useState(false)

  const [visibility3, setVisibility3] = useState(false)

  // functions visibility Menu

  const visibilityFood = () => {
    setVisibility1(true)
    setVisibility2(false)
    setVisibility3(false)
  }


  const visibilityDesserts = () => {
    setVisibility1(false)
    setVisibility2(true)
    setVisibility3(false)
  }


  const visibilityDrinks = () => {
    setVisibility1(false)
    setVisibility2(false)
    setVisibility3(true)
  }


  useEffect(() => {
    setInitiatedComprobated(true)
  }, [])


  // cuerpo objeto {name: "", kcal: 0, peso: 0, ingredients: ""}
  const [stateNumberPetitions, setNumberPetitions] = useState(1)
  const [orderIdCounter, setOrderIdCounter] = useState(1);


  const generateUniqueId = () => {
    const currentId = orderIdCounter; // Guarda el ID actual
    setOrderIdCounter(prevId => prevId + 1); // Incrementa el contador
    return currentId; // Devuelve el ID actual
  };


  


const addProductToCar = (product) => {
    if (tableNumber && product.price) {
      const petitions = Number(stateNumberPetitions); // Asegúrate de que `stateNumberPetitions` es un número
  
      // Actualizar el total correctamente utilizando el valor previo
      setTotalPay((prevTotalPay) => prevTotalPay + (product.price * petitions));
  
      // Actualizar la cantidad de productos correctamente
setProductCuantity((prevProductCuantity) => Number(prevProductCuantity) + petitions);
  
      // Condición para crear múltiples productos solo si petitions es mayor a 0
      let multipleArray = [];
      if (petitions > 0) {
        
        multipleArray = new Array(petitions).fill(null).map(() => ({
          ...product,
          date: new Date().toString(),
          id: generateUniqueId(), // Generar un id único para cada copia
          forHome: false,
        }));
        setNumberPetitions(1)
      }
  
      // Actualizar la lista de productos en el carrito solo si multipleArray tiene productos
      if (multipleArray.length > 0) {
        setProductsToCar((prevState) => [
          ...prevState,  // Mantener los productos anteriores
          ...multipleArray, // Agregar las nuevas copias del producto
        ]);

      }
  
      // Otros estados de actualización
      setOrderSucessFull(""); 
      setNumberBurgers((prevNumberBurgers) => prevNumberBurgers + petitions);  // Asegurarse de que el valor sea numérico
      setVisibilityPreSend(false);
      setTemporalItemState("");
      setNumberPetitions(0);
  
      // Verificar si el producto ya existe en el carrito y actualizar el contador
      const sameProduct = productsTocar.find((pro) => pro.name === product.name);
      if (sameProduct) {
        setNumberSameProduct((prevNumberSameProduct) => prevNumberSameProduct + 1);
      }
    } else if (!tableNumber) {
      setAlertTable((prevAlertTable) => prevAlertTable + 1);
    }
  };
  

  

  const addProductToCarForHome = (product) => {
    if (tableNumber && product.price) {
      const petitions = Number(stateNumberPetitions); // Asegúrate de que `stateNumberPetitions` es un número
  
      // Actualizar el total correctamente utilizando el valor previo
      setTotalPay((prevTotalPay) => prevTotalPay + (product.price * petitions));
  
      // Actualizar la cantidad de productos correctamente
setProductCuantity((prevProductCuantity) => Number(prevProductCuantity) + petitions);
  
      // Condición para crear múltiples productos solo si petitions es mayor a 0
      let multipleArray = [];
      if (petitions > 0) {
        multipleArray = new Array(petitions).fill(null).map(() => ({
          ...product,
          date: new Date().toString(),
          id: generateUniqueId(), // Generar un id único para cada copia
          forHome: true,
        }));
        setNumberPetitions(1)
      }
  
      // Actualizar la lista de productos en el carrito solo si multipleArray tiene productos
      if (multipleArray.length > 0) {
        setProductsToCar((prevState) => [
          ...prevState,  // Mantener los productos anteriores
          ...multipleArray, // Agregar las nuevas copias del producto
        ]);
      }
  
      // Otros estados de actualización
      setOrderSucessFull(""); 
      setNumberBurgers((prevNumberBurgers) => prevNumberBurgers + petitions);  // Asegurarse de que el valor sea numérico
      setVisibilityPreSend(false);
      setTemporalItemState("");
      setNumberPetitions(0);
  
      // Verificar si el producto ya existe en el carrito y actualizar el contador
      const sameProduct = productsTocar.find((pro) => pro.name === product.name);
      if (sameProduct) {
        setNumberSameProduct((prevNumberSameProduct) => prevNumberSameProduct + 1);
      }
    } else if (!tableNumber) {
      setAlertTable((prevAlertTable) => prevAlertTable + 1);
    }
  };
    

  const functionMapeoFood = (arrayFood) => {
    return arrayFood.map((food, index) => {
      return (
        <div className="card-food" key={index}>
          <div className="container-img-food">
            <img className="img-food" src={food.imagen} />
          </div>
          <div style={{ padding: "1px", height: "100px" }}>

            <h1>{food.name}</h1>
            <h2>{food.kcal} kCal</h2>
            <p>{food.ingredients}</p>
          </div>

          <div style={{ padding: "1.5px", marginTop: "100px" }} className="container-btn-menu">
            <p>{food.price}</p>
            {!englishActivate && <button
              className="secondary-button"
              onClick={() => visibilityPreSendFunction(food)}
            >
              Añadir
            </button>}

            {
              englishActivate && <button
              className="secondary-button"
              onClick={() => visibilityPreSendFunction(food)}
            >
              Add
            </button>
            }
          </div>
        </div>
      );
    });
  };



  // LOGICA DEL CHAT

  const [changeForm, setChangeForm] = useState("");
  const [newMessageChat, setNewMessageChat] = useState(0)
  const [visibilityMessages, setVisibilityMessages] = useState(false)
  const socketRefChat = useRef(null);

  // Conexión WebSocket
  useEffect(() => {

    socketRefChat.current = io(api25, {
      path: "/socket",
      transports: ['websocket', 'polling'],
    });

    socketRefChat.current.on('connect', () => {
      setConsoleAdmin(prevState => [...prevState, "Conectado a WebSocket"]);
    });

    socketRefChat.current.on('connect_error', (error) => {
      setConsoleAdmin(prevState => [...prevState, 'Error al conectar con WebSocket:', error]);
    });

    socketRefChat.current.on('nuevoMensaje', (mensaje) => {
      setConsoleAdmin(prevState => [...prevState, 'Nuevo mensaje recibido:', mensaje]);
      setMensajes((prevMensajes) => [...prevMensajes, mensaje]);

      setVisibilityMessages(true)
    });
    
    

    return () => {
      socketRefChat.current.disconnect();
    };
  }, []);

  // CHAT CLIENTE

  useEffect(() => {
    if (!visibilityChatClient & mensajes.length > 0) {
      setNewMessageChat(newMessageChat + 1)
    }
  }, [mensajes])

  useEffect(() => {

    if (!visibilityChatClient) {
      // const sound = '/Outlook notification sound.mp3';
      const audio = new Audio(chatSound); // Ruta correcta si el archivo está en la carpeta public
      audio.play().catch(error => {
        setConsoleAdmin(prevState => [...prevState, "Error al reproducir el sonido:", error]);
      });
    }
  }, [newMessageChat]);


  // Función para manejar el cambio en el input
  const changeFormFunction = (e) => {
    setChangeForm(e.target.value);
  };

  // Función para manejar el envío del mensaje
  const sendFormFunction = (e) => {
    if (changeForm) {
      e.preventDefault();
      const mensaje = {
        text: changeForm,
        timestamp: new Date().toISOString(),
        mesa: `Mesa ${tableNumber}`
      };
      setConsoleAdmin(prevState => [...prevState, 'Enviando mensaje:', mensaje]);
      socketRefChat.current.emit('mensajeChat', mensaje); // Emitir el mensaje al servidor
      setChangeForm(""); // Limpiar el input después de enviar
    }
    else if (!changeForm) {
      alert("Escribir el mensaje")
    }
  };

  const chatContainerRef = useRef(null)
  useEffect(() => {
    // Accedemos al contenedor de los mensajes
    const chatContainer = document.getElementById('chat-container-2');



    if (chatContainer) {
      // Desplazamos al final del contenedor cada vez que los mensajes cambien
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }, [mensajes, visibilityChatClient]);



  const closeChatFunction = (e) => {
    e.preventDefault()
    setVisibilityChatClient(false)
  }

  const chatFunction = () => {
    return (
      <div className="container-chat-admin-3" id='chat-admin'>
        <div style={{ marginTop: "-5px" }}>
          <button className='primary-button' onClick={(e) => closeChatFunction(e)}>X</button>
        </div>
        <form className='form-chat-user-2' onSubmit={sendFormFunction} style={{ overflowX: "hidden", overflowY: "hidden" }}>
          <div className='container-impresion-chat-3' id="chat-container-2" style={{ overflowX: "hidden" }}>
            <div>
              {mensajes.length > 0 ? (
                mensajes.map((msg, index) => (
                  <div key={index} className="message-container-2">
                    <div style={{ color: "white" }}>
                      <p>{msg.mesa} dice:</p>
                      <p className="text-chat-admin-2" style={{ display: "flex", flexDirection: "column" }}>
                        {msg.text} <small>{new Date(msg.timestamp).toLocaleTimeString()}</small>
                      </p>
                    </div>

                  </div>
                ))
              ) : (
                <p>{englishActivate ? "Not are messages" : "No hay mensajes."}</p>
              )}
            </div>
          </div>
          <div className='container-logo-chat-2'>
            <img className='img-logo-chat-2' alt="logo" src={imgLogo} />
          </div>
          <div className='container-texarea-user-2' style={{ overflowX: "hidden" }}>
            {!englishActivate && <textarea
              value={changeForm}
              onChange={changeFormFunction}
              className='textarea-chat-user'
              placeholder="Escribiir mensaje a Burger Shop."
            />}
            {englishActivate && <textarea
              value={changeForm}
              onChange={changeFormFunction}
              className='textarea-chat-user'
              placeholder="Reading message to Burger Shop."
            />}
            {!englishActivate && <button type="submit" className='btn-chat-send-2'>ENVIAR</button>}
            {englishActivate && <button type="submit" className='btn-chat-send-2'>SEND</button>}
         
          </div>
        </form>
      </div>
    );
  };


  // LOGICA MUSICA

  const [playMusic, setPlayMusic] = useState(false)

  const handleForMusic = () => {
    // Mostrar una ventana de confirmación para preguntar al usuario

    setPlayMusic(!playMusic);

  };



  useEffect(() => {
    let audio
    if (playMusic) {
      audio = new Audio(music); // Ruta correcta si el archivo está en la carpeta public
      audio.play().catch(error => {
        setConsoleAdmin(prevState => [...prevState, "Error al reproducir el sonido:", error]);
      });
    }
    else {
      console.log("No Music")
    }


    return () => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    }

  }, [playMusic]);

  // LOGICA IDIOMAS

  const [englishActivate, setEnglishActivate] = useState(false)

  const englishActivateFunction = (e) => {
    e.preventDefault()
    setEnglishActivate(true)
  }


  const englishDesactivateFunction = (e) => {
    e.preventDefault()
    setEnglishActivate(false)
  }
  
  const [temporalItemState, setTemporalItemState] = useState()
  // LOGICA PRESEND

  const visibilityPreSendFunction = (food) => {
    setTemporalItemState(food)
    setVisibilityPreSend(true)
    setNumberPetitions(1)   
    setVisibilityChatClient(false) 
  }


  const functionNumberPetitions = (e) => {
    setNumberPetitions(e.target.value)
  }

  const closeFunctionPreSend = () => {
    setVisibilityPreSend(false)
  }
  

  const functionPreSend = () => {
    return(
      <div className='container-function-pre-send'>
        <button onClick={() => closeFunctionPreSend()}>x</button>
      {englishActivate && <div className='container-title-pre-send'>
          <h2 style={{color: "white"}}>Select type of request.</h2>
        </div>
}
       {!englishActivate && <div className='container-title-pre-send'>
          <h2 style={{color: "white"}}>Seleccione tipo de pedido</h2>
        </div>
}
        <div className='container-number-petitions'>
          <img className='img-food-presend' src={temporalItemState.imagen} />
          <input id='numberImput' style={{width: ""}} type='number' max="99" min="1" step="1" value={stateNumberPetitions} onChange={(e) => functionNumberPetitions(e)}/>
        </div>

{
  englishActivate && <div className='container-btns-pre-send'>
  <button id='mesa' onClick={() => addProductToCarForHome(temporalItemState)}>Home</button>
  <button id='domicilio' onClick={() => addProductToCar(temporalItemState)}>Table</button>
</div>
}  {
!englishActivate &&   <div className='container-btns-pre-send'>
          <button id='mesa' onClick={() => addProductToCarForHome(temporalItemState)}>Domicilio</button>
          <button id='domicilio' onClick={() => addProductToCar(temporalItemState)}>Mesa</button>
        </div>
   }   </div>
    )
  }

  
  
  // RETURN CENTRAl




  return (
    <div>
      {visibilityClientFrontend && (
        <React.Fragment>


          <div className="client-container">


            <div className="container-hamburguesas">

              {/* <div className="container-logo"> */}

                {/* <h2 className="client-container-p">Cliente</h2>
              </div> */}

              <div className="food-container">

                {/* mapeo diferentes comidas */}
                {/* <div className="container-food-menue"> */}
                <nav className="navigate-food">

                  <div>
                    <button className='btn-music' onClick={() => handleForMusic()}> <img src={musicLogo} className='icono-btn' /></button>
                  </div>
                  <div className='container-lenguage-btn'>
                    <button  id='btn-english' className="button-chic-minimalista-lenguage" onClick={(e) => englishActivateFunction(e)}></button>
                    <button  id='btn-spanish' className="button-chic-minimalista-lenguage" onClick={(e) => englishDesactivateFunction(e)}></button>
                  </div>
                  {/* <img className="icono-btn-lenguage" src={imgIconEspaña} /> */}
                  {/* <img className="icono-btn-lenguage" src={imgIconUsa} /> */}
                  <Barnav
                   setVisibilityPreSend={setVisibilityPreSend}
                  api25={api25}
                  freeVersion={freeVersion}
                  englishActivate={englishActivate}
                    setConsoleAdmin={setConsoleAdmin}
                    consoleAdmin={consoleAdmin}
                    tableNumber={tableNumber}
                    mensajes={mensajes}
                    newMessageChat={newMessageChat}
                    visibilityChatClient={visibilityChatClient}
                    setVisibilityChatClient={setVisibilityChatClient}
                    setVisibilityClientFrontend={setVisibilityClientFrontend}
                    setSecurityAdmin={setSecurityAdmin}
                    numberOrders={numberOrders}
                    setVisibilityHamburguesas={setVisibilityHamburguesas}
                    setVisibilityCar={setVisibilityCar}
                    visibilityCar={visibilityCar}
                    numberBurgers={numberBurgers}
                  />
                  <div className='buttons-navigate-food-container'>
                    <button className="button-chic-minimalista" onClick={() => visibilityFood()}><img src={iconoHamburguesa} className='icono-btn' /></button>
                    <button className="button-chic-minimalista" onClick={() => visibilityDesserts()}><img src={iconoPostre} className='icono-btn' /></button>
                    <button className="button-chic-minimalista" onClick={() => visibilityDrinks()}><img src={iconoBebida} className='icono-btn' /></button>
                    {/* <img src={logoMacDonalds} className="icono-logo" /> */}
               
                  </div>
                </nav>
                <div className='container-mapeo-function-food'>
                  {visibility1 && !englishActivate && functionMapeoFood(hamburguesas)}
                  {/* </div> */}
                  {/* <div className='container-mapeo-function-food'> */}
                  {visibility1 && englishActivate && functionMapeoFood(burgers)}
                  {/* </div> */}
                {/* <div className='container-mapeo-function-food'> */}
                  {visibility2 && englishActivate && functionMapeoFood(dessertsEnglish)}
                 {/* </div> */}
                 {/* <div className='container-mapeo-function-food'> */}
                  {visibility2 && !englishActivate && functionMapeoFood(desserts)}
                {/* </div> */}
                {/* <div className='container-mapeo-function-food'> */}
                {visibility3 && functionMapeoFood(drinks)}
                </div>
                {/* </div> */}

              </div>
              {visibilityCar && numberOrders < 4 && (
                <Carbuy ip1={ip1}
                centralApi={centralApi}
                api25={api25}
                englishActivate={englishActivate}
                  setConsoleAdmin={setConsoleAdmin}
                  consoleAdmin={consoleAdmin}
                  setNumberOrders={setNumberOrders}
                  alert={alert}
                  numberOrders={numberOrders}
                  setBuy={setBuy}
                  buy={buy}
                  tableNumber={tableNumber}
                  setTotalPay={setTotalPay}
                  setProductsToCar={setProductsToCar}
                  totalPay={totalPay}
                  productsTocar={productsTocar}
                  orderSucessFull={orderSucessFull}
                  setOrderSucessFull={setOrderSucessFull}
                  numberBurgers={numberBurgers}
                  setNumberBurgers={setNumberBurgers}
                  numberSameProduct={numberSameProduct}
                  setVisibilityCar={setVisibilityCar}
                />
              )}
            </div>
            {visibilityChatClient &&
              <div>
                {chatFunction()}
              </div>
            }

            {
              visibilityPreSend && functionPreSend()
            }
          </div>
          {/* <Footer /> */}
        </React.Fragment>
      )}
{/* {
  visibilityAdmin && <React.Fragment>
    <Admin
  </React.Fragment>
} */}
    </div>
  )
}

export default Home